import script from "./TaskTableTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTableTab.vue?vue&type=script&setup=true&lang=js"

import "./TaskTableTab.vue?vue&type=style&index=0&id=0d96ef9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d96ef9c"]])

export default __exports__